

if(!customElements.get('facets-component')) {
  customElements.define('facets-component', 
    class Facets extends HTMLElement {
      constructor() {
          super();
          this.sectionID = this.dataset.sectionId;
          this.openFacetsButton = this.querySelector('[data-open-filters]');
          this.closeFiltersButtons = this.querySelectorAll('[data-close-filter]');
          this.filtersCount = this.querySelector('[data-filter-count]');
          this.filtersPopup = this.querySelector('[data-filter-popup]');
          this.openSortButton = this.querySelector('[data-open-sort]');
          this.sortDropdown = this.querySelector('[data-sort-dropdown]');
          this.openSubcollectionsButton = this.querySelector('[data-open-subcollections]');
          this.subcollections = this.querySelector('[data-subcollections]');
          this.collectionContainer = document.querySelector('[data-collection-container]');
          this.filtersForm = this.filtersPopup.querySelector('form') || null;
          this.clearFiltersButton = this.filtersPopup.querySelector('[data-clear-filters ]') || null;
          this.sortOptions = this.sortDropdown.querySelectorAll('input') || null;
      }

      connectedCallback() {
        this.openSubcollections();
        this.openSort();
        this.openFilters();
        this.closeFilters();
        this.handleSort();
        this.handleFilterSubmit();
        this.clearFilters();
        this.popstateListener();
      }

      openSubcollections() {
        if(!this.openSubcollectionsButton || !this.subcollections) return;
        this.openSubcollectionsButton.addEventListener('click', () =>  {
          this.subcollections.classList.toggle('hidden');
          const buttonIcon =  this.openSubcollectionsButton.querySelector('span');
          this.subcollections.classList.contains('hidden') ? buttonIcon.classList.replace('-rotate-90', 'rotate-90') : buttonIcon.classList.replace('rotate-90', '-rotate-90');
        })
      }

      openSort() {
        if(!this.openSortButton && !this.sortDropdown) return;
        this.openSortButton.addEventListener('click', ()=> {
          this.sortDropdown.classList.toggle('hidden');
        })

        document.addEventListener('click', (event) => {
          if (!this.sortDropdown.contains(event.target) && !this.openSortButton.contains(event.target)) {
            this.sortDropdown.classList.add('hidden');
          }
        });
      }

      openFilters() {
        if(!this.openFacetsButton && !this.filtersPopup) return;
        this.openFacetsButton.addEventListener('click', ()=> {
          this.filtersPopup.classList.add('active');
          const overlay = this.querySelector('[data-filter-overlay]');
          if(!overlay) return;
          overlay.classList.add('active'); 
        })
      }
      
      closeFilters() {
        if(!this.closeFiltersButtons.length === 0 && !this.filtersPopup) return;
        this.closeFiltersButtons.forEach(button => {
          button.addEventListener('click', ()=> this.handleCloseFilters());
        })
      }

      clearFilters() {
        if(!this.clearFiltersButton) return;
        this.clearFiltersButton.addEventListener('click', async (event) => {
          event.preventDefault();      
          await this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
        })
      }

      handleCloseFilters() {
        this.filtersPopup.classList.remove('active');
        const overlay = this.querySelector('[data-filter-overlay]');
        if(!overlay) return;
        overlay.classList.remove('active'); 
      }

      handleSort() {
        if(!this.sortOptions || this.sortOptions.length === 0) return;
        this.sortOptions.forEach(option => {
          option.addEventListener('input', async (event)=> await this.filterFormSubmit(event));
        })
      }

      handleFilterSubmit() {
        if(!this.filtersForm) return;
        this.filtersForm.addEventListener('submit', async (event)=> {
          event.preventDefault()
          await this.filterFormSubmit(event);
        })
      }

      async filterFormSubmit(e) {
        let form = e.target.form;

        if (e.target.tagName.toLowerCase() === 'form') {
          form = e.target;
        }
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);
        searchParams.delete('price_range');    
        await this.renderPage(searchParams.toString(), e);
      }

      async renderPage(searchParams, updateURLHash = true) {
        const url = `${window.location.pathname}?section_id=${this.sectionID}&${searchParams}`;
        const response = await fetch(url);
        if (!response.ok) return;
        const result = await response.text();
        const parser = new DOMParser().parseFromString(result, 'text/html');
        const newContainer = parser.querySelector('[data-collection-container]');
        const newFacets = parser.querySelector('facets-component');
        this.collectionContainer.innerHTML = newContainer.innerHTML;
        this.outerHTML = newFacets.outerHTML;
        this.handleCloseFilters();
        if (updateURLHash) this.updateURLHash(searchParams);
      }

      updateURLHash(searchParams) {
        history.pushState(
          { searchParams },
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`
        );
      }

      popstateListener() {
        window.addEventListener('popstate', async () => {
          await this.renderPage(window.location.search);
        })
      }
    }
  )
}